import React from 'react';

/**
 * ModulePill — dark navy background, gold Oswald-uppercase text,
 * small gold dot. Use everywhere we display a "Module n" label so
 * the visual rhythm stays identical across the site.
 *
 * Props:
 *   number   — the module number to render (e.g. 1, 2, "1.7")
 *   compact  — slightly smaller padding/font when true (for tight rows)
 *   children — optional label override (e.g. "Module 1: Intro"); defaults
 *              to "Module {number}"
 */
const ModulePill = ({ number, compact = false, children, className = '', ...rest }) => {
  const label = children || (number != null ? `Module ${number}` : 'Module');
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${className}`}
      style={{
        background: 'var(--gr-navy)',
        color: 'var(--gr-gold)',
        fontFamily: '"Oswald", sans-serif',
        fontWeight: 700,
        letterSpacing: '0.14em',
        fontSize: compact ? '10.5px' : '12px',
        textTransform: 'uppercase',
        padding: compact ? '3px 10px' : '5px 12px',
        borderRadius: '6px',
        border: '1px solid var(--gr-navy-dark)',
        boxShadow: '0 1px 2px rgba(26,43,76,0.18)',
        whiteSpace: 'nowrap',
      }}
      data-testid={`module-pill-${number != null ? number : 'generic'}`}
      {...rest}
    >
      <span
        style={{
          display: 'inline-block',
          width: '6px',
          height: '6px',
          borderRadius: '999px',
          background: 'var(--gr-gold)',
        }}
      />
      {label}
    </span>
  );
};

export default ModulePill;
